// extracted by mini-css-extract-plugin
export default {"avatar":"g4kl0G6","avatar--clickable":"TjIT75i"};